// extracted by mini-css-extract-plugin
export default {"container":"home_container__QTCYN","animate1":"home_animate1__gPeHk"};